var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.75 12.25C41.2875 12.25 36 17.5375 36 24L36.0588 42.6825C36.0588 45.7962 37.2925 48.7337 39.4663 50.9663L59.5 71L39.4663 91.1513C37.2925 93.325 36.0588 96.3213 36.0588 99.435L36 118C36 124.463 41.2875 129.75 47.75 129.75H94.75C101.213 129.75 106.5 124.463 106.5 118V99.435C106.5 96.3213 105.266 93.325 103.092 91.1513L83 71L103.034 51.025C105.266 48.7925 106.5 45.7962 106.5 42.6825V24C106.5 17.5375 101.213 12.25 94.75 12.25H47.75ZM94.75 99.8463V112.125C94.75 115.356 92.1063 118 88.875 118H53.625C50.3938 118 47.75 115.356 47.75 112.125V99.8463C47.75 98.26 48.3962 96.7913 49.4537 95.675L71.25 73.9375L93.0462 95.7337C94.1038 96.7912 94.75 98.3187 94.75 99.8463Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorReply);
export default __webpack_public_path__ + "static/media/VendorReply.2290f1ffa309fc131146ffecc854e57c.svg";
export { ForwardRef as ReactComponent };